import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { AppShell } from '@/app/layout/app-shell';
import { meQuery } from '@/lib/auth/session';

// Every section needs a session: without one, the login with the way back.
export const Route = createFileRoute('/_app')({
  beforeLoad: async ({ context, location }) => {
    const user = await context.queryClient.ensureQueryData(meQuery);
    if (!user) throw redirect({ to: '/login', search: { redirect: location.href } });
    // ADR 0059: an invitation's temporary password is replaced before anything else.
    if (user.must_change_password) throw redirect({ to: '/password', search: { redirect: location.href } });
    // ADR 0067: on the public host the owner turns on TOTP before anything else.
    if (user.totp_setup_required) throw redirect({ to: '/totp-setup', search: { redirect: location.href } });
    return { user };
  },
  component: AppLayout,
});

function AppLayout() {
  const { user } = Route.useRouteContext();
  return (
    <AppShell user={user}>
      <Outlet />
    </AppShell>
  );
}
